import React from "react";
import { Col, Container, Row } from "reactstrap";

function Footer() {

    return (
        <footer className="footer">
            <Container fluid>
                <Row>
                    <Col sm={12} className="text-center text-dark">
                        {new Date().getFullYear()} © WiseRep. All Rights Reserved
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
